export interface CirclePoint { lat: number; lng: number }
export const CIRCLE_KM_PER_DEGREE = 111.32;

export function circleFromDiameter(points: readonly CirclePoint[], unwrap = false) {
  const first = points[0], last = points[points.length - 1];
  const lastLng = unwrap ? first.lng + ((last.lng - first.lng + 180) % 360 + 360) % 360 - 180 : last.lng;
  const center = { lat: (first.lat + last.lat) / 2, lng: (first.lng + lastLng) / 2 };
  const radiusKm = Math.hypot((first.lat - center.lat) * CIRCLE_KM_PER_DEGREE,
    (first.lng - center.lng) * CIRCLE_KM_PER_DEGREE * Math.cos(center.lat * Math.PI / 180));
  return { center, radiusKm };
}

export function circleDiameterPoints(center: CirclePoint, radiusKm: number): CirclePoint[] {
  const offset = radiusKm / CIRCLE_KM_PER_DEGREE;
  return [{ lat: center.lat + offset, lng: center.lng }, { lat: center.lat - offset, lng: center.lng }];
}

export function circleRing(center: CirclePoint, radiusKm: number, options: { earthRadiusKm: number; samples: number; closed: boolean; wrapLongitude: boolean }): CirclePoint[] {
  const lat1 = center.lat * Math.PI / 180, lng1 = center.lng * Math.PI / 180;
  const angle = radiusKm / options.earthRadiusKm;
  const points = Array.from({ length: options.samples }, (_, index) => {
    const bearing = index / options.samples * Math.PI * 2;
    const lat = Math.asin(Math.sin(lat1) * Math.cos(angle) + Math.cos(lat1) * Math.sin(angle) * Math.cos(bearing));
    const lng = (lng1 + Math.atan2(Math.sin(bearing) * Math.sin(angle) * Math.cos(lat1), Math.cos(angle) - Math.sin(lat1) * Math.sin(lat))) * 180 / Math.PI;
    return { lat: lat * 180 / Math.PI, lng: options.wrapLongitude ? ((lng + 540) % 360) - 180 : lng };
  });
  if (options.closed && points.length) points.push({ ...points[0] });
  return points;
}
